export default {
  'layout.appBar.userDropdown.nightMode': 'Night Mode',
  'layout.appBar.userDropdown.lightMode': 'Light Mode',
  'layout.appBar.userDropdown.settings': 'Settings',
  'layout.appBar.userDropdown.logout': 'Logout',
  'layout.appBar.userDropdown.about': 'About',
  'layout.appBar.userDropdown.privacy': 'Privacy policy',
  'layout.appBar.notificationDropdown.notifications': 'Notifications',
  'layout.appBar.notificationDropdown.reminders': 'Reminders',
  'layout.appBar.notificationDropdown.empty': 'Empty',
  'layout.appBar.notificationDropdown.seeAll': 'See all',
  'layout.menu.dashboard': 'Home',
  'layout.menu.customers': 'Customers',
  'layout.menu.indicators': 'Indicators',
  'layout.menu.customers.create': 'New customer',
  'layout.menu.customers.details': 'Details',
  'layout.menu.customers.details.generalInfo': 'General Info',
  'layout.menu.customers.details.addresses': 'Address',
  'layout.menu.customers.details.contacts': 'Contacts',
  'layout.menu.customers.details.vehicles': 'Vehicles',
  'layout.menu.customers.details.bankInfo': 'Bank Info',
  'layout.menu.customers.details.servicesHistory': 'Services History',
  'layout.menu.operational': 'Operational',
  'layout.menu.operational.inventory': 'Inventory',

  'layout.menu.operational.inventory.parts': 'Parts',
  'layout.menu.operational.inventory.parts.create': 'Create Part',
  'layout.menu.operational.inventory.parts.details': 'Part Details',
  'layout.menu.operational.inventory.parts.details.general': 'General Info',
  'layout.menu.operational.inventory.parts.details.stock': 'Stock',
  'layout.menu.operational.inventory.parts.details.application': 'Applications',
  'layout.menu.operational.inventory.parts.details.lastPurchases':
    'Latest part purchases',
  'layout.menu.operational.inventory.parts.details.replacementParts':
    'Replacement Parts',
  'layout.menu.operational.inventory.parts.details.latestPartPurchases':
    'Latest Part Purchases',

  'layout.menu.operational.inventory.consumables': 'Consumables',
  'layout.menu.operational.inventory.consumables.create':
    'Create New Consumables',
  'layout.menu.operational.inventory.consumables.details.general': 'General',
  'layout.menu.operational.inventory.consumables.details.stock': 'Stock',
  'layout.menu.operational.inventory.consumables.details.lastConsumablePurchases':
    'Latest input purchases',
  'layout.menu.operational.inventory.consumables.details.inventory':
    'Inventory',
  'layout.menu.operational.inventory.consumables.details.lastPurchases':
    'Last Purchases',
  'layout.menu.operational.inventory.manufacturers': 'Manufacturers',
  'layout.menu.operational.inventory.groups': 'Groups',
  'layout.menu.operational.inventory.groups.list': 'Groups',
  'layout.menu.operational.inventory.groups.create': 'Create New Group',
  'layout.menu.operational.inventory.groups.general': 'General',
  'layout.menu.operational.kits': 'Kits',
  'layout.menu.operational.kits.create': 'Create New Kit',
  'layout.menu.operational.kits.detail': 'Detail Kit',
  'layout.menu.operational.tasks': 'Tasks',
  'layout.menu.operational.tasks.create': 'Create New Task',
  'layout.menu.operational.tasks.details': 'Details',
  'layout.menu.operational.tasks.details.general': 'General data',
  'layout.menu.operational.tasks.details.applications': 'Applications',
  'layout.menu.operational.areas': 'Areas',
  'layout.menu.operational.areas.create': 'Create New Area',
  'layout.menu.operational.areas.details': 'Area Details',
  'layout.menu.operational.accessories': 'Accessories',
  'layout.menu.registry': 'Registry',
  'layout.menu.registry.companies': 'Companies',
  'layout.menu.registry.companies.create': 'Create New Company',
  'layout.menu.registry.companies.list': 'Companies',
  'layout.menu.registry.companies.general': 'General',
  'layout.menu.registry.companies.settings': 'Settings',
  'layout.menu.registry.companies.customTerms': 'Custom Terms',
  'layout.menu.registry.companies.invoice': 'Invoice',
  'layout.menu.registry.companies.coupon': 'Taxe Coupon',
  'layout.menu.registry.companies.sintegra': 'Sintegra',
  'layout.menu.registry.companies.settings.priceComposition':
    'Price Composition',
  'layout.menu.registry.companies.settings.profitCostComposition':
    'Profit Cost Composition',
  'layout.menu.registry.companies.settings.itemTags': 'Work Order Item Tags',
  'layout.menu.registry.companies.settings.financial': 'Financial',
  'layout.menu.registry.companies.settings.stoneIntegration':
    'Stone Integration',
  'layout.menu.registry.companies.settings.boschCoreCredentials':
    'Credenciais Bosch CoRe',
  'layout.menu.registry.companies.saveText': 'Save',
  'layout.menu.registry.companies.deleteText': 'Delete Company',
  'layout.menu.registry.companies..contract.bankSlips': 'Bank slip contract',
  'layout.menu.registry.employee': 'Employee',
  'layout.menu.registry.employee.create': 'Create New Employee',
  'layout.menu.registry.employee.list': 'Employee',
  'layout.menu.registry.employee.personal': 'Personal Data',
  'layout.menu.registry.employee.professional': 'Professional Data',
  'layout.menu.registry.employee.contact': 'Contacts',
  'layout.menu.registry.employee.address': 'Address',
  'layout.menu.registry.employee.saveText': 'Save',
  'layout.menu.registry.employee.deleteText': 'Remove Employee',
  'layout.menu.registry.suppliers': 'Suppliers',
  'layout.menu.registry.suppliers.create': 'Create New Supplier',
  'layout.menu.registry.suppliers.general': 'General',
  'layout.menu.registry.suppliers.address': 'Address',
  'layout.menu.registry.suppliers.contacts': 'Contacts',
  'layout.menu.registry.suppliers.credit': 'Credit Breakdown',
  'layout.menu.registry.suppliers.returnedItems': 'Returned Items',
  'layout.menu.registry.insurers': 'Insurers',
  'layout.menu.registry.insurers.create': 'New Insurer',
  'layout.menu.registry.insurers.general': 'General',
  'layout.menu.registry.insurers.addresses': 'Address',
  'layout.menu.registry.insurers.contacts': 'Contacts',
  'layout.menu.registry.insurers.deleteText': 'Remove insurer',
  'layout.menu.registry.insurers.saveText': 'Save',
  'layout.menu.registry.insurers.newContact': 'New Contact',
  'layout.menu.registry.cardAdministrators': 'Card Administrators',
  'layout.menu.registry.insurers.newAddress': 'New Address',
  'layout.menu.registry.transport': 'Transport',
  'layout.menu.registry.transport.create': 'New Transport',
  'layout.menu.registry.functions': 'Functions',
  'layout.menu.registry.bankAccounts': 'Bank Accounts',
  'layout.menu.registry.bankAccounts.create': 'Create New Bank Account',
  'layout.menu.registry.billToPay.release.create': 'Create New Bill To Pay',
  'layout.menu.registry.billToPay.release.detail': 'Installment Details',
  'layout.menu.registry.billToPay.release.attachments': 'Account Attachments',
  'layout.menu.registry.bankEntry.release.create': 'Create New Bank Entry',
  'layout.menu.registry.bankEntry.release.detail': 'Detail Bank Entry',
  'layout.menu.registry.billToPay.predictions.create': 'Create New Prediction',
  'layout.menu.registry.billToPay.predictions.details': 'Detail Previsão',
  'layout.menu.registry.billToRelease.release.create':
    'Create New Bill To Receive',
  'layout.menu.registry.billToRelease.release.detail': 'Detail Bill To Receive',
  'layout.menu.registry.billToRelease.release.attachments':
    'Account Attachment',
  'layout.menu.registry.bankAccounts.details': 'Bank Account Details',
  'layout.menu.registry.bankAccounts.general': 'Bank Account Details',
  'layout.menu.registry.bankAccounts.contacts': 'Bank Account Contacts',
  'layout.menu.registry.bankAccounts.configBankSlip': 'Bank slip configuration',
  'layout.menu.notifications': 'Notifications',
  'layout.menu.notifications.create': 'Create Notification',
  'layout.menu.settings': 'Settings',
  'layout.menu.settings.account': 'Account',
  'layout.menu.settings.registration': 'Registration',
  'layout.menu.settings.workorderConfiguration': 'Workorder Settings',
  'layout.menu.settings.linkingAccounts': 'Linking Accounts',
  'layout.menu.settings.financialConfiguration': 'Financial Configuration',
  'layout.menu.settings.tagsWorkOrder': 'Tags for workorder',
  'layout.menu.settings.tagsdirectSale': 'Tags Direct Sale',
  'layout.menu.settings.tagsAccountsPayableAndReceivable':
    'Tags Accounts payable and receivable',
  'layout.menu.settings.financial': 'Financial Settings',
  'layout.menu.settings.customer': 'Customer Configuration',
  'layout.menu.settings.partsConfiguration': 'Parts Settings',
  'layout.menu.settings.system': 'System',
  'layout.menu.settings.profiles': 'Profiles',
  'layout.menu.settings.emailSettings': 'Email Settings',
  'layout.menu.settings.emailUserSettings': 'Email User Settings',
  'layout.menu.settings.passwordSettings': 'Password Settings',
  'layout.menu.settings.registrations': 'Registrations',
  'layout.menu.settings.movements': 'Movements',
  'layout.menu.settings.reports': 'Reports',
  'layout.menu.settings.crm': 'CRM',
  'layout.menu.settings.emailSettingsCrm': 'Email Settings Crm',
  'layout.menu.settings.profiles.create': 'Create New Group',
  'layout.menu.settings.profiles.details': 'Details',
  'layout.menu.settings.users': 'Users',
  'layout.menu.settings.fiscal': 'Fiscal',
  'layout.menu.settings.whatsapp.templates': 'Whatsapp Templates',
  'layout.menu.settings.stone': 'Stone',
  'layout.menu.settings.users.create': 'Create New User',
  'layout.menu.tax': 'Tax',
  'layout.menu.tax.receipt': 'Receipt',
  'layout.menu.tax.receipt.general': 'General',
  'layout.menu.tax.receipt.receiver': 'Receiver',
  'layout.menu.tax.receipt.delivery': 'Delivery',
  'layout.menu.tax.receipt.items': 'Note items',
  'layout.menu.tax.receipt.taxes': 'Taxes',
  'layout.menu.tax.receipt.transport': 'Transport',
  'layout.menu.tax.receipt.payments': 'Payments',
  'layout.menu.tax.receipt.additional': 'Additional data',
  'layout.overview.receivables': 'Receivables',
  'layout.overview.payables': 'Payables',
  'layout.overview.openServices': 'Open services',
  'layout.overview.budgets': 'Budgets',
  'layout.overview.searchParts': 'Search Parts',
  'layout.overview.newBudget': 'Create New Budget',
  'layout.menu.movements': 'Movements',
  'layout.menu.movements.budgets.visualManagement': 'Visual Management',
  'layout.menu.movements.budgets.generalData': 'General Data',
  'layout.menu.movements.budgets.partsSupplies': 'Parts and Supplies',
  'layout.menu.movements.budgets.commissions': 'Commissions',

  'layout.menu.movements.workOrders': 'Work Orders',
  'layout.menu.movements.workOrders.migration': 'Work Orders Migrated',
  'layout.menu.movements.workOrders.calendar': 'Follow-up',
  'layout.menu.movements.workOrders.indicators': 'Indicators',
  'layout.menu.movements.workOrders.details': 'Work Order Details',
  'layout.menu.movements.workOrders.details.import': 'Work Order Import',
  'layout.menu.movements.workOrders.details.checklist': 'Work Order Checklist',
  'layout.menu.movements.workOrders.details.checklist.detail':
    'Work Order Checklist Detail',
  'layout.menu.movements.workOrders.details.checklist.damages': 'Damages',
  'layout.menu.movements.workOrders.details.checklist.images': 'Images',
  'layout.menu.movements.workOrders.details.checklist.observations':
    'Observations',
  'layout.menu.movements.workOrders.details.checklist.accessories':
    'Accessories',
  'layout.menu.movements.workOrders.details.checklist.requestedServices':
    'Requested Services',
  'layout.menu.movements.workOrders.details.checklist.quickChecklist':
    'Quick Checklist',
  'layout.menu.movements.workOrders.details.checklist.complementItems':
    'Complement Items',
  'layout.menu.movements.workOrders.details.checklist.futureServices':
    'Future Services',
  'layout.menu.movements.workOrders.details.generalInfo': 'General Info',
  'layout.menu.movements.workOrders.details.partsAndTasks': 'Parts And Tasks',
  'layout.menu.movements.workOrders.details.observations': 'Observations',
  'layout.menu.movements.workOrders.details.financial': 'Financial',
  'layout.menu.movements.workOrders.details.invoice': 'Invoice',
  'layout.menu.movements.workOrders.details.emails': 'E-mails',
  'layout.menu.movements.workOrders.details.commissions': 'Commissions',
  'layout.menu.movements.workOrders.details.history': 'History',

  'layout.menu.movements.directSale': 'Direct Sale',
  'layout.menu.movements.directSale.indicators': 'Direct Sale Indicators',
  'layout.menu.movements.directSale.create': 'Direct Sale Create',
  'layout.menu.movements.directSale.details': 'Direct Sale Details',
  'layout.menu.movements.directSale.details.general': 'General Data',
  'layout.menu.movement.directSale.financial': 'Financial',

  'layout.menu.movements.inventory': 'Inventory',
  'layout.menu.movements.inventory.details': 'Inventory Details',

  'layout.menu.movements.purchases': 'Purchases',
  'layout.menu.movements.purchases.releases': 'Releases',
  'layout.menu.movements.purchases.create': 'New Buy',
  'layout.menu.movements.purchases.details': 'Details',
  'layout.menu.movements.purchases.details.general': 'General',
  'layout.menu.movements.purchases.details.itemsPurchase': 'Items Purchase',
  'layout.menu.movements.purchases.details.itemsPurchase.create':
    'Purchase Item Creation',
  'layout.menu.movements.purchases.details.itemsPurchase.details':
    'Purchase Item Details',
  'layout.menu.movements.purchases.details.data.freight': 'Shipping data',
  'layout.menu.movements.purchases.details.taxes': 'Taxes',
  'layout.menu.movements.purchases.details.groupings': 'Grouped Purchases',
  'layout.menu.movements.purchases.details.financial': 'Financial',
  'layout.menu.movements.purchaseReturn': 'Purchase Return',
  'layout.menu.movements.purchases.purchasingGrouping': 'Purchasing Grouping',
  'layout.menu.movements.purchases.purchasingImport': 'Purchase Import',
  'layout.menu.movements.purchases.partsLink24': 'PartsLink24',
  'layout.menu.movements.purchases.wom': 'WOM',
  'layout.menu.movements.purchases.womPurchaseImport': 'WOM Purchase Import',
  'layout.menu.movements.purchases.purchasingConfirmImport':
    'Purchase Import Confirm',

  'layout.menu.movements.deliveryOrReturnOfMaterials':
    'Delivery/Return of Materials',
  'layout.menu.movements.deliveryOrReturnOfMaterials.deliverMaterial':
    'Deliver Material',
  'layout.menu.movements.deliveryOrReturnOfMaterials.returnMaterial':
    'Return Material',

  'layout.menu.movements.diagnostics': 'Diagnostics',
  'layout.menu.movements.diagnostics.create': 'New diagnostic',
  'layout.menu.movements.diagnostics.details': 'Diagnostic Details',
  'layout.menu.movements.quotations': 'Quotations',
  'layout.menu.movements.quotations.details': 'Details',
  'layout.menu.movements.quotations.details.items': 'Items',
  'layout.menu.movements.quotations.details.suppliers': 'Suppliers',
  'layout.menu.movements.quotations.details.offersConfiguration':
    'Offers Configuration',
  'layout.menu.movements.quotations.details.requestQuotation':
    'Request Quotation',

  'layout.menu.movements.stockCorrections': 'Stock Corrections',
  'layout.menu.movements.stockCorrections.create': 'Create Stock Correction',
  'layout.menu.movements.stockCorrections.details': 'Stock Correction Details',

  'layout.menu.movements.stockTransfer': 'Stock Transfer',
  'layout.menu.movements.stockTransfer.create': 'Stock transfer create',
  'layout.menu.movements.stockTransfer.details': 'Stock transfer details',

  'layout.menu.movements.employeeCommissions': 'Employee Commissions',

  'layout.menu.financial': 'Financial',
  'layout.menu.sales': 'Sales',
  'layout.menu.invoicing': 'Invoicing',
  'layout.menu.financial.accounts': 'Accounts',
  'layout.menu.financial.accounts.planAccounts': 'Plan Accounts',
  'layout.menu.financial.accounts.documentTypes': 'Documents Types',
  'layout.menu.financial.accounts.documentTypes.details':
    'Document Type Details',
  'layout.menu.financial.accounts.documentTypes.details.general': 'General',
  'layout.menu.financial.accounts.documentTypes.details.rates': 'Rates',
  'layout.menu.financial.accounts.paymentConditions': 'Payment Conditions',
  'layout.menu.financial.accounts.costCenters': 'Cost Centers',

  'layout.menu.financial.billToPay': 'Bills To Pay',
  'layout.menu.financial.billToPay.releases': 'Releases',
  'layout.menu.financial.billToPay.releases.migration.consult':
    'Migration releases',
  'layout.menu.financial.billToPay.predictions': 'Predictions',
  'layout.menu.financial.billToPay.grouping': 'Groupings',
  'layout.menu.financial.billToPay.calendar': 'Calendar',
  'layout.menu.financial.billToReceive': 'Bills To Receive',
  'layout.menu.financial.billToReceive.releases': 'Releases',
  'layout.menu.financial.billToReceive.releases.migration.consult':
    'Migration releases',
  'layout.menu.financial.billToReceive.grouping': 'Groupings',
  'layout.menu.financial.bankEntry': 'Bank Entry',
  'layout.menu.financial.bankEntry.releases': 'Releases',
  'layout.menu.financial.cashMovement': 'Cash Movement',
  'layout.menu.financial.bankSlip': 'Bank slips',
  'layout.menu.financial.bankSlipHistory': 'History Tickets',
  'layout.menu.financial.bankSlipHistory.detail': 'Ticket Details',
  'layout.menu.financial.generateShippingFile': 'Generate Shipping File',
  'layout.menu.financial.readReturnFile': 'Read Return File',
  'layout.menu.financial.bankConciliation': 'Bank Conciliation',

  'layout.menu.fiscal': 'Fiscal',
  'layout.menu.fiscal.ncm': 'NCM',
  'layout.menu.fiscal.ncm.create': 'Create',
  'layout.menu.fiscal.ncm.details': 'Details',
  'layout.menu.fiscal.coupon': 'Tax Coupon (SAT)',
  'layout.menu.fiscal.invoice': 'Invoice',
  'layout.menu.fiscal.invoice.table.type': 'Type',
  'layout.menu.fiscal.invoice.table.model': 'Model',
  'layout.menu.fiscal.invoice.table.series': 'Series',
  'layout.menu.fiscal.invoice.table.number': 'Number',
  'layout.menu.fiscal.invoice.table.issuer': 'Issuer',
  'layout.menu.fiscal.invoice.table.acessKey': 'Acess Key',
  'layout.menu.fiscal.invoice.table.issueDate': 'Issue Date',
  'layout.menu.fiscal.invoice.table.uf': 'UF',
  'layout.menu.fiscal.invoice.table.save': 'Save',
  'layout.menu.fiscal.invoice.table.cancel': 'Cancel',
  'layout.menu.fiscal.invoice.referenced': 'Referenced Documents',
  'layout.menu.fiscal.invoice.referenced.select.customer': 'Customer',
  'layout.menu.fiscal.invoice.referenced.select.provider': 'Provider',
  'layout.menu.fiscal.invoice.referenced.select.insuranceCompany':
    'Insurance Company',
  'layout.menu.fiscal.invoice.referenced.list.fantasyName': 'Fantasy Name',
  'layout.menu.fiscal.invoice.referenced.list.name': 'Name',
  'layout.menu.fiscal.invoice.newDocument': 'New document',
  'layout.menu.fiscal.invoice.createNFe': 'Create NF-e',
  'layout.menu.fiscal.invoice.details': 'Details',
  'layout.menu.fiscal.invoice.detailsNFe': 'Details NF-e',
  'layout.menu.fiscal.invoice.detailsNFCe': 'Details NFC-e',
  'layout.menu.fiscal.invoice.detailsNFSe': 'Details NFS-e',
  'layout.menu.fiscal.invoice.createNFe.datasNFe': 'NF-e Datas',
  'layout.menu.fiscal.invoice.createNFe.additionalData': 'Additional Data',
  'layout.menu.fiscal.invoice.create.recipient': 'Recipient',
  'layout.menu.fiscal.invoice.createNFCe': 'Create NFC-e',
  'layout.menu.fiscal.invoice.createNFCe.datasNFCe': 'NFC-e Datas',
  'layout.menu.fiscal.invoice.createNFSe': 'Create NFS-e',
  'layout.menu.fiscal.invoice.createNFSe.datasNFSe': 'NFS-e Datas',
  'layout.menu.fiscal.invoice.disableNumberingRange': 'Disable Numbering Range',
  'layout.menu.fiscal.invoice.sped': 'SPED',
  'layout.menu.fiscal.invoice.spedDocuments': 'Documents',
  'layout.menu.fiscal.invoice.spedDocuments.detail': 'Document detail',
  'layout.menu.fiscal.invoice.spedConfig': 'Config',
  'layout.menu.fiscal.invoice.sintegra': 'Sintegra',
  'layout.menu.fiscal.invoice.downloadXML': 'Download XML files',
  'layout.menu.fiscal.invoice.cfe': 'Tax Coupon',
  'layout.menu.fiscal.invoice.manifestationRecipient':
    'Recipients Manifestation',

  'layout.menu.fiscal.invoice.cfe.general': 'CF-e Datas',
  'layout.menu.fiscal.invoice.cfe.recipient': 'Recipient',
  'layout.menu.fiscal.invoice.cfe.items': 'Coupon items',
  'layout.menu.fiscal.invoice.cfe.payments': 'Payments methods',

  'layout.menu.schedules': 'Schedules',
  'layout.menu.schedules.courtyard': 'Courtyard',
  'layout.menu.schedules.accompaniment': 'Accompaniment',
  'layout.menu.schedules.requests': 'Requests',
  'layout.menu.schedules.scheduling': 'Scheduling',
  'layout.menu.schedules.operation': 'Operation',
  'layout.menu.schedules.services': 'Services',
  'layout.menu.schedules.customerRating': 'Customer Rating',
  'layout.menu.schedules.employee': 'Employee',

  'layout.menu.reports': 'Reports',
  'layout.menu.reports.movement': 'Movement',
  'layout.menu.movement.workOrders': 'Budgets',
  'layout.menu.movement.dailyMovement': 'Daily Movement',
  'layout.menu.movement.directSale': 'Direct Sale',
  'layout.menu.movement.osXFinancial': 'OS x Financial',
  'layout.menu.movement.osXInvoice': 'OS x Invoice',
  'layout.menu.movement.directSaleXFinancial': 'DS x Financial',
  'layout.menu.movement.futureServices': 'Future Services',
  'layout.menu.movement.customerWithoutMovement': 'Customer Without Movement',
  'layout.menu.movement.vehicleWithoutMovement': 'Vehicles Without Movement',
  'layout.menu.movement.abcCurve': 'ABC Curve',
  'layout.menu.reports.purchases': 'Purchases',
  'layout.menu.reports.returnedPurchases': 'Returned Purchases',
  'layout.menu.reports.purchases.quotation': 'Quotation',
  'layout.menu.reports.purchases.AbcCurve': 'Abc Curve',
  'layout.menu.reports.stock': 'Stock',
  'layout.menu.stock.ABCAnalysis': 'ABC Analysis',
  'layout.menu.stock.deliveryOfMaterials': 'Delivery Of Materials',
  'layout.menu.stock.consolidated': 'Consolidated',
  'layout.menu.stock.minimumStock': 'Minimum Stock',
  'layout.menu.reports.financial': 'Financial',
  'layout.menu.financial.billsToPay': 'Bills To Pay',
  'layout.menu.financial.billsToReceive': 'Bills To Receive',
  'layout.menu.financial.balancete': 'Balancete',
  'layout.menu.financial.cashFlow': 'Cash Flow',
  'layout.menu.financial.dre': 'Income Statement',
  'layout.menu.reports.commission': 'Comission',
  'layout.menu.movement.byMovement': 'By Movement',
  'layout.menu.movement.byFinancial': 'By Financial',
  'layout.menu.reports.productive': 'Productive',
  'layout.menu.productive.hoursSold': 'Hours Sold',
  'layout.menu.productive.hoursCost': 'Hours Cost',
  'layout.menu.reports.managerial': 'managerial',
  'layout.menu.managerial.invoicing': 'Invoicing',
  'layout.menu.managerial.cost': 'Cost',
  'layout.menu.managerial.audit': 'Audit',
  'layout.menu.managerial.repeatedVehicles': 'Repeated Vehicles',
  'layout.menu.movement.fiscalReport': 'Fiscal',
  'layout.menu.movement.fiscalReport.invoice': 'Invoice',
  'layout.menu.movement.fiscalReport.invoiceNoteItems': 'Note Items',
  'layout.menu.movement.fiscalReport.invoiceNFSIntallments': 'Installments',
  'layout.menu.movement.fiscalReport.invoiceDeductions': 'Deductions',
  'layout.menu.movement.fiscalReport.salesByCST': 'Sales By CST',
  'layout.menu.reports.yardManagement': 'Yard Management',

  'layout.menu.history': 'History',
  'layout.menu.vehicleHistory': 'Vehicle History',
  'layout.menu.plateHistory': 'Plate History',
  'layout.menu.emailHistory': 'Sent emails',

  'layout.menu.resultAnalysis': 'Result Analysis',
  'layout.menu.managementCharts': 'Management Charts',

  'layout.menu.informative': 'informative',
  'layout.menu.workshopInformation': 'workshop information',
  'layout.menu.newsletterDetails': 'Newsletter details',

  'layout.menu.crm': 'CRM',
  'layout.menu.crm.shippingOptions': 'Shipping Options',
  'layout.menu.crm.shippingOptions.emailMontage': 'Email Montage',
  'layout.menu.crm.shippingOptions.customerSelection': 'Customer Selection',
  'layout.menu.crm.shippingOptions.finalize': 'Finalize',
  'layout.menu.crm.searchQuestionnaire': 'Search Questionnaire',
  'layout.menu.crm.searchQuestionnaire.create': 'Create',
  'layout.menu.crm.searchQuestionnaire.details': 'Details',
  'layout.menu.crm.searchQuestionnaire.details.syntheticAnalysis':
    'Synthetic Analysis',
  'layout.menu.crm.searchQuestionnaire.details.individualAnalysis':
    'Individual Analysis',
};
